<template>
  <div class="container">
    <!-- 2. 실내 타입 안내 (Room Types Section) -->
    <section class="section intro padding-top">
      <div class="container">
        <h2 class="section-title">실내 타입 안내</h2>
        <div class="room-types-grid">
          <!-- 15형 -->
          <div class="room-card" 
              @mouseenter="mouseHoverIn15 = true" 
              @mouseleave="mouseHoverIn15 = false" 
              @click="openPopup('15')">
            <h3 class="room-title">15 TYPE</h3>
            <div class="image-wrapper">
              <img src="@/assets/15-mosaIFfE3r.jpeg" class="intro-image" />
              <div class="hover-overlay" v-if="mouseHoverIn15">
                <p class="hover-text">이미지를 누르시면 상세한 내부 사진을 볼 수 있습니다.</p>
              </div>
            </div>
            <div class="room-info">
              <p class="room-area">25.01㎡ (계약면적기준)</p>
              <p class="room-area">일반공급 : 82세대</p>
              <p class="room-area">특별공급 : 34세대</p>
              <p class="room-desc">전 세대 보증보험 가입 완료</p>
            </div>
          </div>

          <!-- 30형 -->
          <div class="room-card" 
              @mouseenter="mouseHoverIn30 = true" 
              @mouseleave="mouseHoverIn30 = false" 
              @click="openPopup('30')">
            <h3 class="room-title">30 TYPE</h3>
            <div class="image-wrapper">
              <img src="@/assets/30-mosaBYbpnD.jpeg" class="intro-image" />
              <div class="hover-overlay" v-if="mouseHoverIn30">
                <p class="hover-text">이미지를 누르시면 상세한 내부 사진을 볼 수 있습니다.</p>
              </div>
            </div>
            <div class="room-info">
              <p class="room-area">50.02㎡ (계약면적기준)</p>
              <p class="room-area">일반공급 : 54세대</p>
              <p class="room-area">&nbsp;</p>
              <p class="room-desc">전 세대 보증보험 가입 완료</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 평면도 안내 -->
    <section class="amenities-section section">
      <div class="container-floor-plan">
        <img src="@/assets/15_floor_plan.jpg" class="image" />
        <img src="@/assets/30_floor_plan.jpg" class="image" />
      </div>
      
      <div class="disclaimer-text-container">
        <p class="disclaimer-text">- 상기 이미지는 소비자의 이해를 돕기 위해 연출된 이미지로 실제와 차이가 있을 수 있습니다.</p>
        <p class="disclaimer-text">- 또한 치수는 이해를 돕기 위한 참고 지수입니다. (가구 반입이나 블라인드 설치 시 내부 치수는 다시 확인하시기 바랍니다.)</p>
        <p class="disclaimer-text">- 호수에 따라 평면이 좌우 대칭이 될 수 있습니다.</p>
    </div>
    </section>

    <!-- 제공 옵션 안내 (Amenities Section) -->
    <section class="amenities-section section">
      <div class="container">
        <h2 class="section-title">제공 옵션 안내</h2>
        <div class="amenities-grid">
          <div class="amenity-item" v-for="(item, index) in amenities" :key="index">
            <div class="amenity-icon">{{ item.icon }}</div>
            <h3 class="amenity-label">{{ item.label }}</h3>
            <div class="amenity-tooltip">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </section>
    
    <!-- 자식 팝업 갤러리 컴포넌트 -->
    <image-gallery 
      :floorType="currentFloorType"
      :isPopupOpen="isPopupOpen"
      @close="closePopup"
    />
  </div>
</template>

<script>
import ImageGallery from "@/components/ImagePupup.vue"; // 자식 컴포넌트 임포트

export default {
  components: {
    ImageGallery,
  },
  data() {
    return {
      imageClass: ['default', 'default'],
      overlayImage: ['15-mosa60kDik.jpeg', '15-mosalFfE3r.jpeg'],
      mouseHoverIn15: false,
      mouseHoverIn30: false,
      currentFloorType: null, // 현재 선택된 층 타입
      isPopupOpen: false, // 팝업 상태
      amenities: [
        {
          icon: '🪑',
          label: '빌트인 붙박이장',
          desc: '넉넉한 수납공간을 제공하는 붙박이장'
        },
        {
          icon: '🧊',
          label: '빌트인 냉장고',
          desc: '에너지 효율적인 빌트인 냉장고'
        },
        {
          icon: '🧺',
          label: '세탁기',
          desc: '고효율 세탁기 기본 제공'
        },
        {
          icon: '❄️',
          label: '에어컨',
          desc: '쾌적한 실내 환경을 위한 에어컨'
        },
        {
          icon: '🔥',
          label: '하이라이트',
          desc: '안전하고 효율적인 하이라이트'
        },
        {
          icon: '🚿',
          label: '분리형 샤워부스',
          desc: '편리한 사용을 위한 분리형 샤워부스'
        },
        {
          icon: '💨',
          label: '전열교환기',
          desc: '에너지 효율적인 환기 시스템'
        },
        {
          icon: '🍲',
          label: '전자레인지',
          desc: '간편한 조리를 위한 전자레인지'
        }
      ]
    };
  },
  methods: {
    openPopup(floorType) {
      this.currentFloorType = floorType; // 클릭된 이미지에 해당하는 값 설정
      this.isPopupOpen = true; // 팝업 열기
    },
    closePopup() {
      this.isPopupOpen = false; // 팝업 닫기
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 80px;
  padding-bottom: 80px;
}

.container-floor-plan {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 80px;
  padding-bottom: 20px;
}

.section {
  width: 100%;
  max-width: 1200px;
  text-align: center;
  margin: 0 auto;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out;
  position: relative;
  overflow: hidden;
  margin-bottom: 40px;
}

.section-title{
  font-size: 4rem;
}

.intro-image {
  width: 100%;
  max-width: 1200px;
  height: auto;
  border-radius: 8px;
  transition: opacity 0.3s ease, transform 0.3s ease;
  cursor: pointer;
}

.intro-image:hover {
  opacity: 0.6; /* 이미지 흐려짐 */
  transform: scale(1.05); /* 약간 확대 */
}

/* ✅ 텍스트 오버레이 (클릭 시 내부 확인 가능) */
.hover-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  color: #ffffff;
  font-size: 1.2rem;
  font-weight: bold;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 8px;
}

.section:hover .hover-overlay {
  opacity: 1;
}

.default {
  margin-bottom: 20px;
}

.padding-top {
  padding-top: 20px;
}

.amenities-section {
  background-color: #ffffff;
  padding: 40px 0;
  margin-bottom: 40px;
}

.amenities-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(140px, 1fr));
  gap: 24px;
  max-width: 800px;
  margin: 0 auto;
}

.amenity-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 20vh;
  max-width: 200px;
  height: auto;
  padding: 16px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.amenity-item:hover {
  background-color: #f9f9f9;
}

.amenity-icon {
  font-size: 80px;
  margin-bottom: 12px;
  color: #4CAF50;
}

.amenity-label {
  font-size: 16px;
  font-weight: 500;
}

.amenity-tooltip {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%) translateY(-100%);
  background-color: #333;
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  width: 150px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 100;
}

.amenity-item:hover .amenity-tooltip {
  opacity: 1;
  visibility: visible;
}

.disclaimer-text-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* ✅ 왼쪽 정렬 */
  max-width: 1200px;
  width: 100%;
  padding-right: 10px;
  padding-top: 0px;
  padding-bottom: 10px;
}

.disclaimer-text {
  text-align: left; /* ✅ 텍스트 왼쪽 정렬 */
  font-size: 0.9rem;
  color: #555;
  margin-left: 20px;
  margin-bottom: 1px; /* ✅ 텍스트 간 간격 */
}
.room-types-grid {
  display: flex;
  justify-content: center;
  gap: 40px; /* 이미지 카드 간격 */
  width: 100%;
  flex-wrap: wrap;
}

.room-card {
  position: relative;
  cursor: pointer;
  transition: transform 0.3s ease;
  width: 45%; /* ✅ 가로로 2개 나란히 */
  max-width: 500px;
  background-color: #f9f9f9;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.room-card:hover .intro-image {
  opacity: 0.7;
  transform: scale(1.05);
}

.image-wrapper {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  margin-bottom: 12px;
}

.intro-image {
  width: 100%;
  height: auto;
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.image {
  width: 100%;
  height: auto;
  max-width: 100%;
}

.hover-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  color: #ffffff;
  font-size: 1.2rem;
  font-weight: bold;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 8px;
}

.room-card:hover .hover-overlay {
  opacity: 1;
}

.room-title {
  text-align: center;
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 8px;
}

.room-info {
  text-align: center;
  margin-top: 12px;
}

.room-area {
  font-size: 1rem;
  font-weight: bold;
  color: #555;
  margin: 4px 0;
}

.room-desc {
  font-size: 0.9rem;
  font-weight: bold;
  color: #666;
}

/* ✅ 반응형: 모바일 (768px 이하) */
@media (max-width: 768px) {
  .container {
    padding-top: 40px;
    padding-bottom: 40px;
  }
  .container-floor-plan {
    padding-top: 40px;
    padding-bottom: 10px;
  }

  .section {
    max-width: 90%;
    margin-bottom: 40px;
  }

  .intro-image {
    width: 100%;
    max-width: 100%;
  }

  .hover-overlay {
    font-size: 1rem;
  }

  .amenities-section {
    padding: 40px 0;
    margin-bottom: 40px;
  }

  .amenities-grid {
    grid-template-columns: repeat(2, 1fr); /* 모바일에서는 2열 */
    gap: 16px;
  }

  .amenity-item {
    padding: 12px;
  }

  .amenity-icon {
    font-size: 40px;
  }

  .amenity-label {
    font-size: 14px;
  }

  .amenity-tooltip {
    font-size: 12px;
    width: 120px;
  }

  .disclaimer-text {
    font-size: 0.85rem;
    max-width: 90%;
  }

  /* ✅ 룸 카드 내부 가운데 정렬 */
  .room-card {
    width: 100%;
    max-width: 100%;
    margin-bottom: 20px;
    text-align: center;
  }

  .room-title {
    text-align: center;
    font-size: 1.4rem;
    font-weight: 700;
  }

  .room-info {
    text-align: center;
    margin-top: 12px;
  }

  .room-area,
  .room-desc {
    font-size: 1rem;
    text-align: center;
    color: #555;
  }

  .image-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .intro-image {
    width: 100%;
    height: auto;
    max-width: 100%;
    border-radius: 8px;
  }

  .image {
    width: 100%;
    height: auto;
    max-width: 100%;
  }

  .hover-overlay {
    font-size: 1rem;
    text-align: center;
  }
}

.bold {
  font-weight: bold;
  font-size: 1.2rem;
}
</style>
